import { globalLanguages, TGlobalLanguages } from "./global_languages";

export interface TGlobalConfig {
  FRONTEND_URL: string;
  BACKEND_URL: string;
  LANGUAGES: TGlobalLanguages;
  TERMS_AND_CONDITIONS_PDF_URL: string;
  PRIVACY_POLICY_PDF_URL: string;
  OKTA: {
    ISSUER: string;
    CLIENT_ID: string;
  };
  logOutVersion: string;
}

export const global_config: TGlobalConfig = {
  FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL as string,
  BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
  LANGUAGES: globalLanguages,
  TERMS_AND_CONDITIONS_PDF_URL:
    "https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/6836259e2aac5657874b9955_Attend%20Terms%20of%20Use%20052425.pdf",
  PRIVACY_POLICY_PDF_URL:
    "https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/683625a812daf6ceadcbe532_Attend%20Privacy%20Policy%20052725.pdf",

  OKTA: {
    // okta
    ISSUER: process.env.NEXT_PUBLIC_OKTA_ISSUER || "https://ids.mlb.com/oauth2/aus1m088yK07noBfh356", // prettier-ignore
    CLIENT_ID: process.env.NEXT_PUBLIC_OKTA_CLIENT_ID || "0oasmcdgh92Jom7TI357", // prettier-ignore
  },

  logOutVersion: process.env.NEXT_PUBLIC_LOG_OUT_VERSION || "v8", // prettier-ignore
};
